import React from "react";
import SelectionComponent from "../InnerComponents/SelectionComponent";
import "../InnerComponents/SelectionComponentContainer.css";
import Container from "./../../Container/Container";
import { FLOORING_PSF } from "./../../../utils/_DATA";

const SizeContent = ({
  data,
  type,
  clickEvent,
  multiple,
  setPriceEvent,
  updateSizing,
  size,
}) => {
  const calculateValue = (option) => {
    if (type === "Sizing") {
      return Number(option.price);
    } else {
      return option.price ? Number(option.price) : Number(option.price_per_sf);
    }
  };

  return (
    <Container classes="SelectionComponentContainer">
      {data.map((option) => {
        return (
          <SelectionComponent
            key={option.id}
            value={calculateValue(option)}
            clickEvent={() => clickEvent(option.price)}
            label={option.name}
            price={option.price}
            type={type}
            multiple={multiple}
            updateSizing={updateSizing}
            size={option.id}
          />
        );
      })}
    </Container>
  );
};

export default SizeContent;
